import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service } from "../../../services/index";
import { SaleDC } from "../../../services/salesDc.service";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { PrintData } from "../../master/print/print";
declare var google;

@Component({
  selector: "jobInvoice",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./jobInvoice.html",
})
export class jobInvoiceComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  printPreview: any;
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    fin_year: "",
    party_id: "",
    party: "",
    shirt_designno: "",
    invno: "",
    dcid: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  invList = [];
  printData;
  box: boolean;
  shirt: boolean;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("invoiceTemplate") invoiceTemplate: TemplateRef<any>;
  @ViewChild("box_printTemplate") box_printTemplate: TemplateRef<any>;
  @ViewChild("detailsTemplate") detailsTemplate: TemplateRef<any>;
  @ViewChild("convertWTemplate") convertWTemplate: TemplateRef<any>;
  @ViewChild("convertRTemplate") convertRTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("finAuto") finAuto;
  @ViewChild("partyAuto") partyAuto;

  finyearCtrl: FormControl = new FormControl();
  finCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  print: boolean = false;
  noofpcs: number;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  invoiceList: any = [];
  totpcs: any;

  constructor(
    public store: Store<fromRootStore.State>,
    private saleDC: SaleDC,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private salesinvservice: SalesInvoiceService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();

    this.getPartyList();
    // this.getInvoiceCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Inv No",
        prop: "invoiceno",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Inv Date",
        prop: "inv_date_formatted",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Party",
        prop: "party_name",
        headerClass: "text-center",
        cellClass: "text-left",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "F.Tot",
        prop: "ftotpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "H.Tot",
        prop: "htotpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Total Pcs",
        prop: "totpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 100,
      },
      // {name: 'No of Designs',prop: 'no_of_design',headerClass:'text-center',cellClass: 'text-center', minWidth: 80,maxWidth: 80,width: 80 },
      {
        name: "Action",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        cellClass: "text-center",
        width: 50,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      {
        name: "Invoice",
        prop: "sno",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.invoiceTemplate,
      },
      {
        name: "Sticker",
        prop: "sno",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.box_printTemplate,
      },
    ];
    if (this.menu.sale_type == "estimate") {
      let obj = {
          name: "Convert-Wholesale",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          cellClass: "text-center",
          sortable: false,
          cellTemplate: this.convertWTemplate,
        },
        obj1 = {
          name: "Convert-Retail",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          cellClass: "text-center",
          sortable: false,
          cellTemplate: this.convertRTemplate,
        };
      this.columns.push(obj);
      this.columns.push(obj1);
    }
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
    a.removeClass("mat-autocomplete-visible");
    setTimeout(function () {
      $("#finyear").focus();
    }, 100);
  }
  boxprintModal(row) {
    let params = {
      party_id: row.party_id,
      dcid: row.dcid,
      invoice_type : 'JOB'
    };
    this.salesinvservice.boxprintModal(params).then((res: any) => {
      this.printPreview = res.data;
    });
  }
  printer() {
    // if(box_print == 'BOX'){
    //     this.noofpcs = 2;
    // }else if(box_print == 'SHIRT'){
    //     this.noofpcs = 1;
    // }
    this.noofpcs = 1;
    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }
    if (this.box == false && this.shirt == false) {
      swal("PLEASE SELECT ATLEAST ONE");
    } else {
      $("#box").prop("checked", false);
      $("#shirt").prop("checked", false);
    }
    let params = {
      noofpcs: this.noofpcs,
      box: this.box,
      shirt: this.shirt,
      designdet: JSON.stringify(this.printPreview),
    };
    this.saleDC.print(params).then((res: any) => {});
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 300);
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party = "";
    this.filter.party_id = "";
    this.filter.dcid = "";
    this.filter.shirt_designno = "";
    this.filter.invno = "";
    this.filter.fin_year ="";
    this.filterPanel.close();
    this.finyearCombo()
  }

  applyFilter(): void {
    this.filterPanel.close();
    if (this.filter.invno == "") {
      this.filter.dcid = "";
    }
    if (this.filter.party == "") {
      this.filter.party_id = "";
    }
    this.jobInvoiceList();
  }

  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.jobInvoiceList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD JOB INVOICE",
          title: "ADD JOB INVOICE",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "ADD JOB INVOICE",
          sale_type: this.menu.sale_type,
        },
      };
    } 
    else if(mode == "View"){
      tabObj = {
        action: "NewTab",
        params: {
          tabName: "VIEW JOB INVOICE",
          title: "VIEW JOB INVOICE",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "VIEW JOB INVOICE",
          sale_type: this.menu.sale_type,
        },
      };
    }
    else if(mode == "Edit"){
      tabObj = {
        action: "NewTab",
        params: {
          tabName: "EDIT JOB INVOICE",
          title: "EDIT JOB INVOICE",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "EDIT JOB INVOICE",
          sale_type: this.menu.sale_type,
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  jobInvoiceList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      sales_type: this.menu.sale_type,
      fin_year: this.filter.fin_year,
      party_name: this.filter.party,
      invoiceno: this.filter.invno,
      shirt_designno: this.filter.shirt_designno,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesinvservice
      .jobInvoiceList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.invoiceList = res.data;
        that.calcTotal();
      });
  }
  calcTotal() {
    for (let i = 0; i < this.invoiceList.length; i++) {
      this.invoiceList[i].totpcs =
        parseInt(this.invoiceList[i].ftotpcs) +
        parseInt(this.invoiceList[i].htotpcs);
      this.invoiceList[i].inv_date_formatted = this.datePipe.transform(
        this.invoiceList[i].dcdt,
        "dd-MM-yyyy"
      );
    }
  }

  printInvoice(row) {
    let params = {
      printType: "invoice",
      party_id: row.party_id,
      dcid: row.dcid,
    };
    this.salesinvservice.jobInvoicePrint(params).then((res: any) => {
      this.printData = res;

      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printcontent = this.printData;
    });
  }
  bsModalRef: BsModalRef;
  //   transport(row){
  //     let params={
  //         printType:'invoice',
  //         party_id:row.party_id,
  //         dcid:row.dcid,

  //     }
  //      this.salesinvservice
  //             .salesInvoicePrint(params)
  //             .then((res: any) => {
  //                 this.printData = res;

  //                 this.bsModalRef = this.modalService.show(PrintData, {
  //             keyboard: false,
  //             ignoreBackdropClick: true,
  //             class:'compWidth-70'
  //         });
  //         this.bsModalRef.content.stkdata = Object.assign({}, row);
  //         this.bsModalRef.content.printcontent = this.printData;

  //         });
  //   }
  viewInvoice(row) {
    let params = {
      printType: "details",
      party_id: row.party_id,
      dcid: row.dcid,
    };
    this.salesinvservice.jobInvoicePrint(params).then((res: any) => {
      // let var = "<div>aaaa</div>"
      this.printData = res;
      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printdet = this.printData;
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
        that.finyearCtrl.setValue(res.data[0].fin_id);
            // that.filter.finYrVal = res.data[0].finyear;
        that.filter.fin_year = res.data[0].finyear;
      that.jobInvoiceList();
    });
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      this.filter.fin_year = fitem["finyear"];
      return fitem["finyear"];
    }
    return "";
  }

  getPartyList() {
    this.salesinvservice.getSalesParty({}).then((res: any) => {
      this.partyList = res;
    });
  }

  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { name: id });
      this.filter.party_id = fitem["genLedid"];
      return fitem["name"];
    }
    return "";
  }
  getInvoiceCombo(name) {
    let partylist = _.filter(this.partyList, { name: name });
    this.filter.party_id = partylist[0]["genLedid"];
    this.filter.invno = "";
    let params = {
      genLedid: partylist[0]["genLedid"],
      page: 1,
      start: 0,
      limit: 100,
    };
    this.salesinvservice.getInvoiceCombo(params).then((res: any) => {
      this.invList = res;
    });
  }
  onClickInvoice(invno) {
    let invlist = _.filter(this.invList, { invoiceno: invno });
    this.filter.dcid = invlist[0].dcid;
  }
  convertToWhole(row) {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.jobInvoiceList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "ADD SALES INVOICE",
        title: "CONVERT TO WHOLESALE",
        tabParent: "MASTER",
        data: row,
        mode: "Convert",
        name: "CONVERT TO WHOLESALE",
        sale_type: this.menu.sale_type,
        to_sale_type: "wholesale",
        tabTitle: "CONVERT TO WHOLESALE",
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }
  convertToRetail(row) {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.jobInvoiceList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "ADD SALES INVOICE",
        title: "CONVERT TO RETAIL",
        tabParent: "MASTER",
        data: row,
        mode: "Convert",
        name: "CONVERT TO RETAIL",
        sale_type: this.menu.sale_type,
        tabTitle: "CONVERT TO RETAIL",
        to_sale_type: "retail",
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  deleteInvoice(row) {
    let that = this;
    row.tabevent = undefined;
    let params = {
      dcid: row.dcid,
    };
    swal({
      title: "Are you sure to delete this Invoice Details?",
      text: "You will not be able to recover this Invoice",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.salesinvservice
          .delete(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.jobInvoiceList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/jobInvoice/jobInvoice.ts